import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { PREFERENCE_KEYS, savePreference } from "../../lib/preferences";
import { ICON_BUTTON } from "../ui/styles";

// Light is the default; a chosen theme is remembered (see lib/preferences).

const ThemeToggle = () => {
  const { t } = useTranslation();
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    savePreference(PREFERENCE_KEYS.theme, next ? "dark" : "light");
  };

  const label = t(dark ? "nav.themeLight" : "nav.themeDark");

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={ICON_BUTTON}
    >
      {dark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};

export default ThemeToggle;
